export default __webpack_public_path__ + "static/media/ic-getin.eb49034a.svg";